<template>
    <v-container fluid>
        <AppBar/>
        <v-row class="mt-5">
          <v-col v-if="userData" cols="12" sm="12">
            <v-card class="mx-0 pa-3" elevation="1">
              <v-simple-table v-if="userData" dense style="width: 100%;">
              <template v-slot:default>
            <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Phone</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ userData.name }}</td>
                    <td>{{ userData.email }}</td>
                    <td>{{ userData.phone }}</td>
                </tr>
            </tbody>
              </template>
            </v-simple-table>
            </v-card>
          </v-col>
           <v-col cols="12" sm="12">
               <p v-if="FlightsBookings.length === 0" class="display-1 font-weight-thin">No flights bookings found</p>
              <v-card outlined>
                <v-data-table
                v-if="FlightsBookings.length > 0"
                :items="FlightsBookings"
                :headers="headers"
                :items-per-page="10"
                class="mx-0 pa-3"
                elevation="1"
                :loading="tableLoad"
                >
                  <template v-slot:item.booking_reference="{ item }">
                    <v-btn text color="blue" @click="showDialog(item)">{{item.booking_reference}}</v-btn>
                  </template>
                  <template v-slot:item.price="{ item }">
                    <span>{{item.price | changeCurrency(item.price)}}</span>
                  </template>
                  <template v-slot:item.booking_date="{ item }">
                    <p v-if="item.booking_date" class="mb-0">{{ getThisDate(item.booking_date.split(' ')[0]) }}</p>
                    <span v-if="item.booking_date" class="caption grey--text darken-2">{{ item.booking_date.split(' ')[1] }}</span>
                  </template>
                  <template v-slot:item.origin="{ item }">
                    <span v-if="item.departureAirport">{{`(${item.departureAirport.code}) ${item.departureAirport.city},${item.departureAirport.country}`}}</span>
                    <span v-else>{{ item.flight_segments[0].departure_location }}</span>
                    <p v-if="item.departureDate" class="body-2 grey--text darken-1">{{getThisDate(item.departureDate)}}</p>
                    <p v-else class="body-2 grey--text darken-1">{{getThisDate(item.flight_segments[0].departure_date)}}</p>
                  </template>
                  <template v-slot:item.dist="{ item }">
                    <span v-if="item.arrivalAirport">{{`(${item.arrivalAirport.code}) ${item.arrivalAirport.city},${item.arrivalAirport.country}`}}</span>
                    <span v-else>{{ item.flight_segments[item.flight_segments.length - 1].arrival_location }}</span>
                    <p v-if="item.arrivalDate" class="body-2 grey--text darken-1">{{getThisDate(item.arrivalDate)}}</p>
                    <p v-else class="body-2 grey--text darken-1">{{getThisDate(item.flight_segments[item.flight_segments.length - 1].arrival_date)}}</p>
                  </template>
                  <template v-slot:item.cancel="{ item }">
                    <v-btn :loading="cancelBtnLoading" :disabled="item.status !== 'Initial' || item.status === 'Cancelled'" text color="error" @click="cancelPnr(item)">Cancel</v-btn>
                  </template>
                  <template v-slot:item.ticketTimeLimit="{ item }">
                    <p v-if="item.ticketTimeLimit" class="mb-0">{{ getThisDate(item.ticketTimeLimit.split(' ')[0]) }}</p>
                    <span v-if="item.ticketTimeLimit" class="caption grey--text darken-2">{{ item.ticketTimeLimit.split(' ')[1] }}</span>
                  </template>
                  <template v-slot:item.ticket_number="{ item }">
                    <p>{{item.ticket_number ? item.ticket_number : 'Not ticketed yet'}}</p>
                  </template>
                </v-data-table>
              </v-card>
           </v-col>
        </v-row>
        <v-container fluid v-if="pnrDialog">
      <v-dialog v-model="pnrDialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar height="60" dark color="secondary">
            <v-toolbar-title height="60" style="height: 80px;" class="mt-10">
              <v-btn icon dark @click="pnrDialog = false">
                <v-icon class="mb-1">mdi-close</v-icon>
              </v-btn>
              <span class="text-h6">{{details.booking_reference}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <ShowPnr :details="details"></showPNR>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    </v-container>
</template>
<script>
import AppBar from '../components/AppBar.vue'
import ShowPnr from '../components/ShowPnr.vue'
import { cancelFlight, headersAuth, profile, userBooking } from '../links'

export default {
  components: {
    AppBar,
    ShowPnr
  },
  data () {
    return {
      dialog: false,
      passwordDialog: false,
      userData: null,
      FlightsBookings: [],
      headers: [
        {
          text: 'PNR',
          align: 'start',
          sortable: false,
          value: 'booking_reference',
          width: 120
        },
        { text: 'Price', value: 'price' },
        { text: 'Status', value: 'status' },
        { text: 'Booked on', value: 'booking_date' },
        { text: 'From', value: 'origin' },
        { text: 'To', value: 'dist' },
        { text: 'ticketTimeLimit', value: 'ticketTimeLimit' },
        { text: 'Payment Type', value: 'payment_type' },
        { text: 'Cancel Pnr', value: 'cancel' }
      ],
      tableLoad: false,
      cancelBtnLoading: false,
      pnrDialog: false,
      loaded: false,
      details: null
    }
  },
  methods: {
    getThisDate (date) {
      const givenDate = date
      const [year, month, day] = givenDate.split('-')
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${day} ${months[month - 1]} ${year}`
    },
    getProfile () {
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      this.$http.get(profile, header).then(response => {
        if (response.body.status === false) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          this.userData = response.body.data
        }
      }, (err) => {
        console.log(err)
        // this.$store.commit('showFeedback', { text: 'Something went wrong', color: 'error' })
      })
    },
    userBooking () {
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      this.tableLoad = true
      this.$http.get(userBooking, header).then(response => {
        if (response.body.status === false) {
          this.tableLoad = false
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          this.tableLoad = false
          this.FlightsBookings = response.body.data.FlightsBookings
          console.log(this.FlightsBookings)
        }
      }, (err) => {
        this.tableLoad = false
        console.log(err)
        // this.$store.commit('showFeedback', { text: 'Something went wrong', color: 'error' })
      })
    },
    cancelPnr (item) {
      this.cancelBtnLoading = true
      const token = this.$store.state.user
      console.log(token)
      const header = { headers: headersAuth(token) }
      const body = { pnr: item.booking_reference }
      console.log(body)
      this.$http.post(cancelFlight, body, header).then(response => {
        this.cancelBtnLoading = false
        if (response.body.status === false) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          this.userBooking()
        }
      }, (err) => {
        console.log(err)
        // this.$store.commit('showFeedback', { text: 'Something went wrong', color: 'error' })
      })
    },
    showDialog (item) {
      this.details = item
      this.pnrDialog = true
    }
  },
  mounted () {
    this.getProfile()
    this.userBooking()
  }
}
</script>
